import React from 'react';
import classNames from 'classnames';
import NavBar from '../NavBar/NavBar';
import styles from './ConsoleLayout.module.css';

function ConsoleLayout({ className, mapSize, juanStyle = false, children }) {
  const pageHeight = window.innerHeight;

  return (
    <div
      className={classNames(
        styles.root,
        {
          [styles.juan]: juanStyle,
          [styles.expand]: mapSize === 'expand'
        },
        className
      )}
      style={{ height: pageHeight, width: '100%' }}
    >
      <div style={{ height: pageHeight }}>
        <NavBar />
      </div>
      {children}
    </div>
  );
}

export default ConsoleLayout;
